class Simulations {
  constructor(api) {
    this.api = api;
  }

  // GET /simulations
  // GET /simulations/{uuid}
  // POST /simulations
  // GET /simulations/{uuid}/data
  // GET /simulations/{uuid}/buildings
  // GET /simulations/{uuid}/pathways

  createSimulationConfig(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/simulation-configs", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createSimulation(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/simulations", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllSimulations(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/simulations")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getSimulationById(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/simulations/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getWorkspacesSimulation(simulationUuid, onSuccess, onError){
    return this.api.http_fibercloud
      .get("v1/workspaces/object/simulation_run/" + simulationUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createSimulation(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/simulations", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getSimulationReport(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/simulations/" + uuid + "/report")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getSimulationDetails(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/simulations/" + uuid + "/data?format=json")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getBuildings(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/simulations/" + uuid + "/buildings")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getPathways(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/simulations/" + uuid + "/pathways")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getConfigurationForms(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/objectforms/fc_simulations?include=tabs") // https://api.dev.weezie.io/v1/objectforms/fc_simulations
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteSimulation(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete(`v1/simulations/${uuid}`)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllWithinPolygonCount(
    endpoint,
    technicalType,
    fieldFilters,
    fieldsToInclude,
    fieldsToAppend,
    usedByNetwork,
    polygon,
    projection,
    isNpv,
    onSuccess,
    onError,
  ) {
    let headers = utils.getHeaders()
    if(isNpv){
      delete headers.workspaceuuid
    }
    if (polygon) {
      headers.selectareatextgeom = polygon
      headers.selectareaprojection = projection
    }
  
    if (technicalType) {
      headers.technicaltype = technicalType
    }
  
    let extras = utils.getPreparedExtras(
      fieldFilters,
      fieldsToInclude,
      fieldsToAppend,
    )
    if (extras !== '') {
      extras = '&' + extras
    }
  
    return this.api.http_fibercloud
      .get(
        'v1/' +
          endpoint +
          '?paginate=false&count=true' +
          extras +
          '&usedbynetwork=' +
          usedByNetwork,
        {
          headers,
        },
      )
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
    }
};

export default Simulations;



// WEBPACK FOOTER //
// ./src/api/simulations.js